module.exports = __webpack_public_path__ + "img/Mampf.c0e446cb.svg";